import React, { useEffect, useState } from "react";

import BASE_URL from "components/BaseUrl/apiConfig";
import { Chart } from "chart.js";

export default function ColumnChart() {
  const [chartData, setChartData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // Initialize with the current year

  const storedUserData = localStorage.getItem('userData');
  let userId = '';
  let groupId = '';

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
  }

  useEffect(() => {
    const fetchData = async () => {
      try {

        const response = await fetch(
          `${BASE_URL}/api/Analytics/GetYearlyExpenseChart?groupId=${groupId}&year=${selectedYear}`
        );
        const data = await response.json();
        setChartData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedYear]);

  useEffect(() => {
    if (chartData.length === 0) return;

    // Destroy the existing chart instance if it exists
    if (window.myBarChart) {
      window.myBarChart.destroy();
    }


    let config = {
      type: "bar",
      data: {
        labels: chartData.map((item) => getMonthName(item.month)),
        datasets: [
          {
            label: "Total Credit",
            backgroundColor: "orange",
            borderColor: "#ed64a6",
            data: chartData.map((item) => item.totalDebit),
            fill: false,
            barThickness: 8,
          },
          {
            label: "Total Debit",
            backgroundColor: "limegreen",
            borderColor: "#3e95cd",
            data: chartData.map((item) => item.totalCredit),
            fill: false,
            barThickness: 8,
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        title: {
          display: false,
          text: "Orders Chart",
        },
        tooltips: {
          mode: "index",
          intersect: false,
        },
        hover: {
          mode: "nearest",
          intersect: true,
        },
        legend: {
          labels: {
            fontColor: "rgba(0,0,0,.4)",
          },
          align: "end",
          position: "bottom",
        },
        scales: {
          xAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "Month",
              },
              gridLines: {
                borderDash: [2],
                borderDashOffset: [2],
                color: "rgba(33, 37, 41, 0.3)",
                zeroLineColor: "rgba(33, 37, 41, 0.3)",
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [2],
              },
            },
          ],
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "Total Expense",
              },
              gridLines: {
                borderDash: [2],
                drawBorder: true,
                borderDashOffset: [2],
                color: "rgba(33, 37, 41, 0.2)",
                zeroLineColor: "rgba(33, 37, 41, 0.15)",
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [2],
              },
            },
          ],
        },

        plugins: {
          datalabels: {
            display: false,
            color: 'brown', // Font color for labels
            font: {
              weight: 'bold', // Bold font weight
              size: 15 ,// Font size in pixels
              family:'Courier'
            },
            formatter: (value) => { // Custom label formatter function to display only value
              return value;
            },
            anchor: 'end'
          }

        }
      },
    };

    let ctx = document.getElementById("bar-chart2").getContext("2d");
    window.myBarChart = new Chart(ctx, config);
  }, [chartData]);

  const getMonthName = (monthNumber) => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return monthNames[parseInt(monthNumber, 10) - 1];
  };

  const handleYearChange = (e) => {
    setSelectedYear(parseInt(e.target.value, 10));
  };

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <div className="rounded mr-4 pl-4 mt-4 bg-transparent">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full max-w-full flex-grow flex-1">
              <div className="flex  justify-between">
                <div>
                  <h2 className="text-blueGray-700 text-xl font-semibold">
                    Months Wise Expenses
                  </h2>
                </div>
                  <div className="mr-4">
                    <select
                      className="bg-white-800 text-black border border-white-600 rounded px-6 py-1 outline-none focus:outline-none w-32"
                      value={selectedYear}
                      onChange={handleYearChange}
                    >
                      {/* Populate with years */}
                      <option value={new Date().getFullYear()}>{new Date().getFullYear()}</option>
                      <option value={new Date().getFullYear() - 1}>{new Date().getFullYear() - 1}</option>
                      {/* Add more years as needed */}
                    </select>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="p-4 flex-auto">
          {/* Chart */}
          <div className="relative h-350-px">
            <canvas id="bar-chart2"></canvas>
          </div>
        </div>
      </div>
    </>
  );
}
